import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "./utils/rem";
Vue.config.productionTip = false;
import 'iview/dist/styles/iview.css';
import "./assets/common.css";
import Echart from './components/echart/index.vue';
import './utils/change'
Vue.component("Echart", Echart);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
